import { render, staticRenderFns } from "./service_introduce.vue?vue&type=template&id=9337722a&scoped=true&"
import script from "./service_introduce.vue?vue&type=script&lang=js&"
export * from "./service_introduce.vue?vue&type=script&lang=js&"
import style0 from "./service_introduce.vue?vue&type=style&index=0&id=9337722a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9337722a",
  null
  
)

export default component.exports